import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import IconGeneralActive from '@/assets/smartcity/general-active.svg';
import Logo from '@/assets/smartcity/logo-light.svg';

const FooterIntro = () => {
  const menu = [
    { name: 'Introduction', link: '#intro' },
    { name: 'Features', link: '#fitur' },
    { name: 'How it Works', link: '#howitworks' },
    { name: 'FAQ', link: '#faq' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <footer className="bg-[#0D0F11] w-full lg:p-[100px] md:p-[20px] sm:p-[20px] xs:p-[20px] lg:mt-[100px] md:mt-[100px] sm:mt-[20px] xs:mt-[30px] flex flex-col justify-center">
      <div className="grid grid-cols-1 items-center lg:grid-cols-2 md:grid-cols-2 gap-6">
        <div className="w-fit">
          <Link to="/">
            <img src={Logo} alt="logo" />
          </Link>
        </div>

        <div className="flex flex-col lg:flex-row md:flex-row gap-6 justify-end ">
          {menu.map((item) => (
            <button
              type="button"
              key={item.name}
              onClick={() => scrollToSection(item.link.replace('#', ''))}
              className="h5 w-fit text-white  "
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 items-center lg:grid-cols-2 md:grid-cols-2 gap-6">
        <div className="w-fit">
          <Link to="/">
            <img src={IconGeneralActive} alt="general" />
          </Link>
        </div>

        <div className=" flex flex-col items-end gap-6 justify-end ">
          <p className="h5 text-white">
            © 2026 Grobogan Public Safety Center. All Rights Reserved.{' '}
          </p>
          <p className="h5 text-white">
            Designed to support faster and more efficient emergency response.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterIntro;
